import {
  Badge,
  Body,
  Box,
  Heading,
  Image,
  SimpleGrid,
  SimpleGridProps,
} from '@hover/blueprint';
import { Link as GatsbyLink } from 'gatsby';
import React, { FC } from 'react';
import { BLOG_CATEGORIES } from '../../constants';
import { IBlogPost } from '../../interfaces/IBlogPost';
import ArrowLink from '../ui/ArrowLink';

interface Props extends SimpleGridProps {
  post: IBlogPost;
}

const BlogHeroPost: FC<Props> = ({ post, ...rest }) => {
  const postCategoryData = BLOG_CATEGORIES.find(
    item => item.value === post.categories[0],
  );
  return (
    <SimpleGrid
      columns={{ base: 1, desktop: 2 }}
      spacing={{ base: 0, desktop: 100 }}
      alignItems="center"
      {...rest}
    >
      <Box flexDir="column" maxW="lg" mb={{ base: 700, desktop: 0 }}>
        {postCategoryData && (
          <Box pb={{ base: 500, tablet: 800 }}>
            <Badge
              colorScheme={postCategoryData.color}
              variant="brand"
              textTransform="uppercase"
            >
              {postCategoryData.value}
            </Badge>
          </Box>
        )}
        {post?.author && (
          <Box pb={200}>
            <Body size={300} fontStyle="italic">
              {post.author}
            </Body>
          </Box>
        )}
        <Heading
          as="h2"
          size={{ base: 500, tablet: 700 }}
          marginBottom={{ base: 400, tablet: 500 }}
          isLight
        >
          {post.title}
        </Heading>
        <Body size={500} pb={500} display={{ base: 'none', tablet: 'flex' }}>
          {post.description.description.replace('\\[…\\]', '')}
        </Body>
        <ArrowLink
          as={GatsbyLink}
          display={{ base: 'none', tablet: 'flex' }}
          to={`/blog/${post.slug}/`}
        >
          Read more
        </ArrowLink>
      </Box>
      <Box h="100%" w="100%" as={GatsbyLink} to={`/blog/${post.slug}/`}>
        <Image
          loading="eager"
          pb={{ base: 500, tablet: 0 }}
          src={post.heroImage.fluid.src}
          alt={post.description.description}
          objectFit="contain"
        />
      </Box>
      <Body
        size={500}
        pb={500}
        fontWeight={{ base: 400, tablet: 400 }}
        display={{ base: 'flex', tablet: 'none' }}
      >
        {post.description.description.replace('\\[…\\]', '')}
      </Body>
      <ArrowLink
        as={GatsbyLink}
        display={{ base: 'flex', tablet: 'none' }}
        to={`/blog/${post.slug}/`}
      >
        Read more
      </ArrowLink>
    </SimpleGrid>
  );
};

export default BlogHeroPost;
